import { ProductTabsProps } from '../types';

export const BILLING_DATA = [
  { id: 'next-billing-date', label: 'Next billing date', hasValue: true },
  {
    id: 'annual-cycle-renews-on',
    label: 'Annual Cycle Renews on',
    hasValue: true,
  },
  { id: 'total-licenses', label: 'Total Licences', hasValue: true },
  {
    id: 'total-licenses-in-use',
    label: 'Total Licences in use',
    hasValue: true,
  },
  { id: 'change-card-details', label: 'Change card details' },
  { id: 'change-billing-details', label: 'Change billing details' },
];

export const AU_STATE_OPTIONS = [
  { code: 'NSW', name: 'New South Wales' },
  { code: 'VIC', name: 'Victoria' },
  { code: 'QLD', name: 'Queensland' },
  { code: 'SA', name: 'South Australia' },
  { code: 'WA', name: 'Western Australia' },
  { code: 'TAS', name: 'Tasmania' },
  { code: 'ACT', name: 'Australian Capital Territory' },
  { code: 'NT', name: 'Northern Territory' },
];

export const PRODUCT_TABS: ProductTabsProps[] = [
  {
    label: 'Core',
    value: 'core',
  },
  {
    label: 'Progress',
    value: 'progress',
  },
  {
    label: 'Tax Plan',
    value: 'taxplan',
  },
  {
    label: 'Engage',
    value: 'engage',
  },
];
